export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11473.6496a574.jpg";